var map = {
	"./0.png": 7112,
	"./1.png": 8241,
	"./2.png": 7162,
	"./3.png": 9075,
	"./4.png": 1676,
	"./5.png": 7589,
	"./6.png": 9758,
	"./7.png": 9255,
	"./8.png": 2896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1337;